import { RootState } from "../../../../store";
import { cloudChiprApi } from "../../../../../services/cloudchipr.api";
import { createResourceExplorerGcpBillingExportDataFixedCacheKey } from "../../../../../components/pages/resource-explorer/components/resource-explorer-card/utils/constants/fixedCacheKeys";

export const createResourceExplorerGcpBillingExportDataLoadingSelector = (
  state: RootState,
): boolean | undefined => {
  return cloudChiprApi.endpoints.postUsersMeOrganisationsCurrentGcpBillingExportData.select(
    createResourceExplorerGcpBillingExportDataFixedCacheKey,
  )(state)?.isLoading;
};
